module.exports = "/fonts/opensans.woff2";